<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container mt-3 p-0">
    <div class="row" v-if="sectionshow==='createlist'">
      <div class="col-12 custom-form-label">
        <div>
          <div v-if="procs.length>0">
            <div @dblclick="editCategory(true)" v-if="!isEditCategory" class="mt-3 center" style="text-align: center;">
              <h2>{{categoryname}}</h2>  <a @click="editCategory(true)" style="cursor: pointer; text-decoration: underline !important;">Edit title</a>
            </div>
            <div class="col-lg-12 p-0 pb-1" v-if="isEditCategory">
              <table style="width:100%"><tr>
                <td style="width:100%"><input @focusout="editCategory(false)" v-model="categoryname" type="text" v-bind:placeholder="$t('list_name')" maxlength="200" class="form-control" /></td>
                <td>
                  <a @click="editCategory(false)" style="cursor:pointer;"><i class="icon-checkmark4 mx-2"></i></a>
                </td>
                </tr>
              </table>
            </div>
            <div>
              {{ procs.length }} tasks
            </div>
          </div>
          <table cellspacing="0" cellpadding="0"
                 class="vuetable table table-hover skin">
            <tbody>
              <tr v-for="proc in procs" class="table-inactive">
                <td class="tablecolumn tablecolumn-Name" style="height: 100%; position: relative;">
                  <!--<div @dblclick="editProc(proc.ProcedureId)">{{ proc.ProcedureName }}</div>-->
                  <div @dblclick="editProcName(proc.ProcedureId)" v-if="proc.ProcedureId!=selectedid">{{ proc.ProcedureName }}</div>
                  <div>
                    <input v-bind:id="'txt_proc_' +  proc.ProcedureId" @focusout="handleFocusout" v-if="proc.ProcedureId===selectedid" v-model="proc.ProcedureName" type="text" maxlength="200" class="form-control" />
                  </div>
                </td>
                <td width="50" style="position: relative; min-width: 50px;">
                  <div style="position: relative;">
                    <a @click="editProcName(proc.ProcedureId)" style="cursor:pointer;" v-if="proc.ProcedureId!==selectedid"><i class="icon-pencil"></i></a>
                    <a @click="handleFocusout" style="cursor:pointer;" v-if="proc.ProcedureId===selectedid"><i class="icon-checkmark4"></i></a>
                    <a @click="deleteProc(proc.ProcedureId)" style="cursor:pointer;margin-left:3px;"><i class="icon-trash"></i></a>

                    <!--<div class="skinnedmenu dropdown dropleft position-static" style="position: relative;">
                    <a href="#" data-toggle="dropdown"
                       data-boundary="viewport" id="headerlink"
                       class="adminmenu list-icons-item caret-0 px-0" style="color: inherit;"
                       aria-expanded="false">
                      <span class="badge badge-pill ml-auto ml-lg-0 px-0"
                            style="width: 26px;">
                        <i class="icon-arrow-down22"
                           style="color: inherit;"></i>
                      </span>
                    </a>


                    <div class="skinnedmenu dropdown-menu dropdown-menu-left pt-1"
                                  x-placement="left-start" style="position: absolute;
  will-change: transform; top: 0px; left: 0px;
  transform: translate3d(-202px, 0px, 0px);">
                          <a @click="editProc(proc.ProcedureId)"
                             class="dropdown-item">Edit</a>
                          <a @click="deleteProc(proc.ProcedureId)" class="dropdown-item">Delete</a>
                        </div>

                  </div>-->
                  </div>
                </td>
              </tr>
            </tbody>
          </table>


        </div>
        <div>
          <button type="button" class="btn skin primary-button btn-icon ml-1"
                  @click="createlist" style="float: right;width: 100%;">
            {{getbuttontext()}} <i class="icon-plus3 ml-1"></i>
          </button>
        </div>

        <div v-if="procs.length>0">
          <button type="button" class="btn skin primary-button mr-1 mt-1"
                  @click="setSectonShow('savelist')" style="float: right;">
            Next
          </button>
        </div>
      </div>
    </div>

    <div class="row" v-if="sectionshow==='savelist'">
      <div class="col-12 custom-form-label">
        <div v-show="procs.length>0">
          <div class="col-lg-12 mb-2">
           <h1>Well done!</h1>
            Please enter you email to save your list
          </div>
          <form class="login-formx form-validate" action="index.html" onsubmit="return false" id="createUserForm">
            <div>
              <div class="col-lg-12">
                <input v-model="useremail" required type="email" v-bind:placeholder="$t('email')" maxlength="200" class="form-control" />
              </div>
            </div>
            <div class="col-lg-12 mt-2">
              <button type="submit" class="btn skin primary-button ml-1"
                      @click="savelist" style="float: right;width: 100%;">
                Save my list
              </button>
            </div>
          </form>
        </div>

        <div v-if="procs.length>0" class="col-lg-12">
          <button type="button" class="btn skin mt-2"
                  @click="setSectonShow('createlist')" style="float: left; background-color: #e3e3e3">
            back
          </button>
        </div>
      </div>
    </div>

    <div class="row" v-show="sectionshow==='sharelist'">
      <share-task-list ref="shareTaskListComp"></share-task-list>      
    </div>
  </div>
</template>

<script>
  export default {
    name: 'create-daily-list',
    components: {
    },
    data() {
      return {
        procs: [],
        id: 0,
        sectionshow: 'createlist',
        useremail: '',
        categoryId: 0,
        selectedid: 0,
        isEditCategory: false,
      }
    },
    props: {
      categoryname: {
        type: String,
        default: "My Daily List"
      },
      initialprocedures: {
        type: String,
        default: null,
      },
    },
    methods: {
      getbuttontext() {
        if (this.procs.length > 0) {
          return "Add";
        } else {
          this.id = 0;
          return "Create " + this.categoryname;
        }
      },
      loadCategoryProcs(data) {
        this.categoryname = data.name;
        this.categoryId = data.categoryid;
        this.useremail = data.username;
        var currentContext = this;
        data.procs.forEach(function (proc) {
          currentContext.procs.push({
            ProcedureId: proc.Id,
            ProcedureName: proc.Name,
            ProcedureScheduleName: "",
            ScheduleWorkNote: "",
            Description: "",
            Elements: [],
            EstimatedTime: 0,
            CategoryId: -1,
            Priority: 0,
            Status: 0,
            NewCategoryName: null,
            Locked: false,
            Private: false,
            Settings: {
              Property: {
                EnablePrivateChat: "True"
              }
            },
            IsTask: true,
            IsEdit: false,
          });
        });

      },
      editCategory(isedit) {
        this.isEditCategory = isedit;
      },
      handleFocusout() {
        this.selectedid = 0;
      },
      setSectonShow(name) {
        this.selectedid = 0;
        this.sectionshow = name;
        vm.$root.$emit('hideRightPanel');
      },
      editProcName(id) {
        this.selectedid = id;
      },
      editProc(id) {
        this.selectedid = 0;//id;
        this.isEditCategory = false;

        //var obj = { procedureId: id };
        //var data = JSON.stringify(obj);

        var item = this.procs.find(n => n.ProcedureId == id);
        if (item != null) {
          vm.$root.$emit('doEditProcedure', item);
        }
        //vm.$root.$emit('doEditProcedure', data);
        //var txtid = 'txt_proc_' + id;
        //alert(txtid);
        //document.getElementById(txtid).focus();
      },
      deleteProc(id) {
        var item = this.procs.find(n => n.ProcedureId == id);
        if (item != null) {
          this.procs.splice(this.procs.indexOf(item), 1);
        }
      },
      async createlist() {
        this.id = this.id + 1;
        this.procs.push({
          ProcedureId: -1 * this.id,
          ProcedureName: "Task " + this.id,
          ProcedureScheduleName: "",
          ScheduleWorkNote: "",
          Description: "",
          Elements: [],
          EstimatedTime: 0,
          CategoryId: -1,
          Priority: 0,
          Status: 0,
          NewCategoryName: null,
          Locked: false,
          Private: false,
          SuccessMessage: "",
          IsEdit: false,
          Settings: {
            Property: {
              EnablePrivateChat: "True"
            }
          },
          IsTask: true
        });

      },

      async addFromText(text) {
        this.id = this.id + 1;
        this.procs.push({
          ProcedureId: -1 * this.id,
          ProcedureName: text,
          ProcedureScheduleName: "",
          ScheduleWorkNote: "",
          Description: "",
          Elements: [],
          EstimatedTime: 0,
          CategoryId: -1,
          Priority: 0,
          Status: 0,
          NewCategoryName: null,
          Locked: false,
          Private: false,
          SuccessMessage: "",
          IsEdit: false,
          Settings: {
            Property: {
              EnablePrivateChat: "True"
            }
          },
          IsTask: true
        });

      },

      async savelist() {
        if (!$('#createUserForm').valid())
          return false;
        var request = {
          procs: this.procs,
          categoryname: this.categoryname,
          username: this.useremail,
          categoryid: this.categoryId,
        };
        try {
          var response = await this.$http.post(
            '/api/microservice/AddProcedures',
            request
          ).then(async response => {
            console.log(response);
            this.categoryId = response.data.categoryid;
            this.$refs.shareTaskListComp.setData(this.categoryId, this.useremail, this.categoryname);
            this.setSectonShow('sharelist');
          })
        } catch (err) {
        }
      }

      //async createlist() {
      //  var request = {
      //    name: "Daily task"
      //  };
      //  try {
      //    var response = await this.$http.post(
      //      '/api/microservice/AddProcedure',
      //      request
      //    ).then(async response => {
      //      console.log(response);
      //      var obj = { procedureId: response.data.ProcedureId };
      //      var data = JSON.stringify(obj);
      //      vm.$root.$emit('doEditProcedure', data);
      //      this.loadprocedures();
      //    })
      //  } catch (err) {
      //  }
      //},
      //async loadprocedures() {
      //  try {
      //    this.procs = [];
      //    var thisContext = this;
      //    this.$http.get('/api/microservice/GetProcedures?').then(response => {
      //      this.procs = response.data;
      //    }).then((response => {
      //    }
      //    ));
      //  } catch (err) {
      //    alert('some error:' + err)
      //  }
      //}
    },
    created() {

    },

    mounted() {
      _componentValidation('#createUserForm');
      if (this.initialprocedures != null && this.initialprocedures != "") {
        var array = this.initialprocedures.split(",");
        for (var i = 0; i < array.length; i++) {
          this.addFromText(array[i]);
        }
      }
    },
    watch: {

    },
    computed: {

    },
  }
</script>



// WEBPACK FOOTER //
// src/components/microservice/create-daily-list.vue